/**
 * Puma
 * @category    ScandiPWA
 * @author      Ricards Nedosvitnijs <info@scandiweb.com>
 * @copyright   Copyright (c) 2021 Scandiweb, Ltd (https://scandiweb.com)
 */

export const UPDATE_PRODUCT_DETAILS = 'UPDATE_PRODUCT_DETAILS';

/**
 * Update product list with new list (rewrite if already exists).
 * @param  {Array<Object>} items List of products returned from fetch
 * @param  {Number} totalItems Total number of products in this filter
 * @return {void}
 * @namespace Scandipwa/Store/Product/Action/updateProductDetails */
export const updateProductDetails = (product, content_html) => ({
    type: UPDATE_PRODUCT_DETAILS,
    product,
    content_html
});
